<template>
  <div class="Trailer-detail  bg-round bg-fff">
    <div class="container">
      <Bread :list="breadList" class="ma-t-10" />
      <div class="flex ma-t-30">
        <img
          :src="detail.Image"
          alt=""
          srcset=""
          width="360"
          height="453"
          class="img_cover img-portrait b-r-15"
        />
        <div class="flex1 pa-l-40">
          <div class="pa-t-20 font-bold fon-30">{{ detail.Name }}</div>
          <div class="font-bold fon-30">{{ detail.EnglishName }}</div>
          <div class="flex ma-t-10">
            <div class="width50">
              导演：{{ detail.Director }}
            </div>
            <div>
              类型：{{ detail.CategoryName }}
            </div>
          </div>
          <div class="flex ma-t-10">
            <div class="width50">
              国家：{{ detail.Areas }}
            </div>
            <div>
              时间：{{ detail.Age }}
            </div>
          </div>
          <div class=" ma-t-10">
            主演：{{ detail.Starrs }}
          </div>
          <div class="white-s-pl ma-t-10 flex">
            剧情：
            <div class="width90">
              {{ detail.Summary }}
            </div>
          </div>
        </div>
      </div>
      <div class="menu-item fon-24 ma-t-80">
        <div class="font-bold">在线观看</div>
        <div class="font-bold">Watch online</div>
        <img
          src="../img/index/index21.png"
          class="item-right width90"
          alt=""
          srcset=""
        />
        <img
          src="../img/index/index22.png"
          class="item-left"
          alt=""
          srcset=""
        />
      </div>
      <div class="ma-t-30">
        <video :src="detail.File" controls class="width100"></video>
      </div>
      <div><div class="xiazai" @click="toPage()">下载预告片</div></div>

      <div class="menu-item fon-24 ma-t-80">
        <div class="font-bold">详细介绍</div>
        <div class="font-bold">Detailed introduction</div>
        <img
          src="../img/index/index21.png"
          class="item-right width90"
          alt=""
          srcset=""
        />
        <img
          src="../img/index/index22.png"
          class="item-left"
          alt=""
          srcset=""
        />
      </div>
      <div v-html="detail.Content" class="lh-html"></div>

    </div>
  </div>
</template>

<script>
  import { getTrailerDetail } from "../api.js";
  export default {
    data(){
      return{
        breadList: [
          {
            name: "国际销售代理",
            path: "/preview/index",
          },
          {
            name: "详情",
            path: "/preview/detail",
          },
        ],
        detail:{}
      }
    },
    created(){
      this.id=this.$route.query.id
      this.loadData()
    },
    methods:{
      loadData(){
        getTrailerDetail({id:this.id}).then(res=>{
          this.detail=res.data.Data
        })
      },
      toPage(){
        location.href=this.detail.File;
      }
    },
    watch:{
      '$route.query.id'(val){
        if(val){
          this.id=this.$route.query.id
          this.loadData()
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
.Trailer-detail .container {
  min-height: 1150px;
  // background: #ffffff;
  box-sizing: border-box;
  padding: 30px 40px;
}
.menu-item {
  position: relative;
  .item-right {
    position: absolute;
    right: 0;
    top: 0;
  }
  .item-left {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.img-portrait {
  border: 4px solid #fb004d;
}
.xiazai{
  width: 148px;
  height: 50px;
  background: #F9014B;
  border-radius: 25px;
  margin-top:50px;
  color:#fff;
  line-height: 50px;
  text-align: center;
}
</style>